<template>
  <div>
    <v-container grid-list-xl>
      <v-layout wrap justify-space-between>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title
              >Has Ortalama: {{ hasAverage | formatMoney }}</v-toolbar-title
            >
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Siparişler</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.orderReports"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Uyum Fatura Durumları</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumDaily"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Siparişler Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.orderMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Uyum Fatura Durumları Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugün En Çok Satılanlar</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.bestSellingProducts"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>En Çok Satılanlar Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.productMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <!-- Tarih Aralığına Göre Gönderilen Altın Özeti -->
        <v-flex xs12 class="mb-4">
          <v-card class="elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">date_range</v-icon>
              <span class="font-weight-bold">Tarih Aralığına Göre Gönderilen Altın Özeti</span>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentStartDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentStartDate"
                        label="Başlangıç Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentStartDate"
                      locale="tr-TR"
                      @input="goldSentStartDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentEndDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentEndDate"
                        label="Bitiş Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentEndDate"
                      locale="tr-TR"
                      @input="goldSentEndDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="goldSentHeaders"
                :items="goldSentTableItems"
                :loading="goldSentLoading"
                hide-actions
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.label }}</td>
                    <td class="text-xs-right font-weight-bold">{{ props.item.value }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- E-Altın Banka Özetleri (Sadece TenantId = 2 için) -->
        <v-flex xs12 mt-4 v-if="tenantId === 2">
          <v-layout row wrap>
            <!-- Yeni Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="amber darken-2 white--text">
                  <v-icon left color="white">new_releases</v-icon>
                  <span class="font-weight-bold">Banka Bazında Yeni Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersStartDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersStartDate"
                            label="Başlangıç Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersStartDate"
                          locale="tr-TR"
                          @input="newOrdersStartDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersEndDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersEndDate"
                            label="Bitiş Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersEndDate"
                          locale="tr-TR"
                          @input="newOrdersEndDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="newOrdersHeaders"
                    :items="newOrdersSummary"
                    :loading="newOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr :class="props.item.bankName === 'DİĞER (1000 milyem)' ? 'grey lighten-3' : ''">
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right amber--text text--darken-3 font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarih aralığında yeni sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Gönderilen Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="success white--text">
                  <v-icon left color="white">done_all</v-icon>
                  <span class="font-weight-bold">Banka Bazında Gönderilen Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 class="px-2">
                      <v-menu
                        v-model="completedOrdersDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="completedOrdersDate"
                            label="İşlem Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="completedOrdersDate"
                          locale="tr-TR"
                          @input="completedOrdersDateMenu = false; loadCompletedOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="completedOrdersHeaders"
                    :items="completedOrdersSummary"
                    :loading="completedOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right success--text font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte gönderilen sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- Gün Bazında Sipariş Kontrol -->
          <v-layout row wrap class="mt-4">
            <v-flex xs12>
              <v-card class="elevation-4">
                <v-card-title class="indigo darken-2 white--text">
                  <v-icon left color="white">table_chart</v-icon>
                  <span class="font-weight-bold">Gün Bazında Sipariş Kontrol</span>
                </v-card-title>

                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm4 class="px-2">
                      <v-menu
                        v-model="ealtinOrderControlDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="ealtinOrderControlDate"
                            label="Tarih"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="ealtinOrderControlDate"
                          locale="tr-TR"
                          @input="ealtinOrderControlDateMenu = false; loadEaltinOrderControl()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm8 class="px-2 d-flex align-center justify-end">
                      <span class="red--text font-weight-bold">
                        Toplam: {{ formatNumber(ealtinOrderControlTotalExpectedSum) }}
                      </span>
                    </v-flex>
                  </v-layout>

                  <!-- Özet (tablodaki verilerden) -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam KDV</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.totalVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Stopaj</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.withholding) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam İşçilik</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.labor) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commission) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon KDV'li</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commissionWithVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Hizmet Bedeli</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.serviceFee) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Has</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgHasPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Satış Fiyatı</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgSalesPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="ealtinOrderControlHeaders"
                    :items="ealtinOrderControlList"
                    :loading="ealtinOrderControlLoading"
                    :pagination.sync="ealtinOrderControlPagination"
                    hide-actions
                    class="elevation-1 ealtin-order-control-table"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td>{{ formatDateOnly(props.item.date) }}</td>
                        <td class="text-no-wrap">{{ props.item.iban }}</td>
                        <td class="text-no-wrap">{{ props.item.bank }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.grams) }}</td>
                        <td class="text-no-wrap">{{ props.item.orderNumber }}</td>
                        <td class="text-no-wrap">{{ props.item.customerName }}</td>
                        <td class="text-no-wrap">{{ props.item.productCode }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.unitPrice) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.invoiceAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commission) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.eGoldVat) }}</td>
                        <td class="text-xs-right font-weight-bold">{{ formatNumber(props.item.totalExpected) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.totalGramWeight) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.hasPrice) }}</td>
                        <td class="text-xs-right">{{ props.item.foreksHas == null ? '-' : formatNumber(props.item.foreksHas) }}</td>
                        <td class="text-xs-right">{{ props.item.averageSalesExchange == null ? '-' : formatNumber(props.item.averageSalesExchange) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.salesAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.labor) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.totalVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.laborWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.withholding) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.serviceFee) }}</td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte kayıt bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import store from "@/store";
import Api from "@/api/baseApi";

export default {
  filters: {
    formatState: function(value) {
      var result = store.getters["orders/getStateItems"].find(
        (el) => el.id == value
      );
      return result.value;
    },
  },
  data: () => {
    const d = new Date();
    const start = new Date(d);
    start.setDate(start.getDate() - 30);
    const end = new Date(d);
    end.setDate(end.getDate() + 1);
    return {
    // Tarih aralığına göre gönderilen altın (varsayılan: son 1 ay)
    goldSentStartDate: start.toISOString().substr(0, 10),
    goldSentEndDate: end.toISOString().substr(0, 10),
    goldSentStartDateMenu: false,
    goldSentEndDateMenu: false,
    goldSentLoading: false,
    goldSentData: { totalGoldSent: 0, totalPayment: 0 },
    goldSentHeaders: [
      { text: 'Özet', value: 'label', sortable: false },
      { text: 'Değer', value: 'value', align: 'right', sortable: false }
    ],
    productMonthly: [],
    orderMonthly: [],
    uyumMonthly: [],
    uyumDaily: [],
    hasAverage: null,
    pagination: {
      sortBy: "name",
    },
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    headers: [
      {
        text: "Sipariş Durumu",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    productHeaders: [
      {
        text: "Ürün",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    // E-Altın Banka Özetleri
    newOrdersStartDate: new Date().toISOString().substr(0, 10),
    newOrdersEndDate: new Date().toISOString().substr(0, 10),
    newOrdersStartDateMenu: false,
    newOrdersEndDateMenu: false,
    newOrdersSummary: [],
    newOrdersLoading: false,
    newOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Yeni Sipariş Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],
    completedOrdersDate: new Date().toISOString().substr(0, 10),
    completedOrdersDateMenu: false,
    completedOrdersSummary: [],
    completedOrdersLoading: false,
    completedOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Gönderilen Altın Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],

    // Gün Bazında Sipariş Kontrol (E-Altın)
    ealtinOrderControlDate: new Date().toISOString().substr(0, 10),
    ealtinOrderControlDateMenu: false,
    ealtinOrderControlLoading: false,
    ealtinOrderControlList: [],
    ealtinOrderControlPagination: { rowsPerPage: -1 },
    ealtinOrderControlHeaders: [
      { text: 'Tarih', value: 'date', sortable: false },
      { text: 'IBAN', value: 'iban', sortable: false },
      { text: 'BANKA', value: 'bank', sortable: false },
      { text: 'GRAM', value: 'grams', align: 'right', sortable: false },
      { text: 'SİPARİŞ NO', value: 'orderNumber', sortable: false },
      { text: 'İSİM', value: 'customerName', sortable: false },
      { text: 'KOD(Ürün adı)', value: 'productCode', sortable: false },
      { text: 'Adet', value: 'quantity', align: 'right', sortable: false },
      { text: 'Birim Fiyatı', value: 'unitPrice', align: 'right', sortable: false },
      { text: 'Fatura Tutarı', value: 'invoiceAmount', align: 'right', sortable: false },
      { text: 'Komisyon', value: 'commission', align: 'right', sortable: false },
      { text: 'Komisyon KDVSİ', value: 'commissionVat', align: 'right', sortable: false },
      { text: 'Komisyon + komisyon Kdvsi', value: 'commissionWithVat', align: 'right', sortable: false },
      { text: 'Ealtın KDV', value: 'eGoldVat', align: 'right', sortable: false },
      { text: 'Toplam', value: 'totalExpected', align: 'right', sortable: false },
      { text: 'Toplam Gramaj', value: 'totalGramWeight', align: 'right', sortable: false },
      { text: 'Has Fiyatı', value: 'hasPrice', align: 'right', sortable: false },
      { text: 'Foreks Has', value: 'foreksHas', align: 'right', sortable: false },
      { text: 'Ortalama Satış Döviz', value: 'averageSalesExchange', align: 'right', sortable: false },
      { text: 'Satış Tutarı', value: 'salesAmount', align: 'right', sortable: false },
      { text: 'İşçilik', value: 'labor', align: 'right', sortable: false },
      { text: 'Toplam KDV', value: 'totalVat', align: 'right', sortable: false },
      { text: 'Kdvli İşçilik', value: 'laborWithVat', align: 'right', sortable: false },
      { text: 'Stopaj', value: 'withholding', align: 'right', sortable: false },
      { text: 'Hizmet Bedeli', value: 'serviceFee', align: 'right', sortable: false },
    ],
  };
  },
  computed: {
    goldSentTableItems() {
      return [
        { label: 'Toplam Gönderilen Altın (GR)', value: this.formatGold(this.goldSentData.totalGoldSent) },
        { label: 'Toplam Ödeme (TL)', value: (this.goldSentData.totalPayment || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺' }
      ];
    },
    tenantId() { 
      const savedTenantId = localStorage.getItem('selectedTenantId');
      return savedTenantId ? parseInt(savedTenantId) : 0;
    }
    ,
    ealtinOrderControlTotalExpectedSum() {
      const list = this.ealtinOrderControlList || [];
      return list.reduce((sum, row) => sum + (Number(row.totalExpected) || 0), 0);
    },
    ealtinOrderControlTotals() {
      const list = this.ealtinOrderControlList || [];
      return list.reduce(
        (acc, row) => {
          acc.totalVat += Number(row.totalVat) || 0;
          acc.withholding += Number(row.withholding) || 0;
          acc.labor += Number(row.labor) || 0;
          acc.commission += Number(row.commission) || 0;
          acc.commissionWithVat += Number(row.commissionWithVat) || 0;
          acc.serviceFee += Number(row.serviceFee) || 0;
          return acc;
        },
        { totalVat: 0, withholding: 0, labor: 0, commission: 0, commissionWithVat: 0, serviceFee: 0 }
      );
    },
    ealtinOrderControlAverages() {
      const list = this.ealtinOrderControlList || [];
      const acc = list.reduce(
        (a, row) => {
          const weight =
            (Number(row.totalGramWeight) || 0) ||
            (Number(row.grams) || 0) ||
            0;
          const hasPrice = Number(row.hasPrice) || 0;
          const salesAmount = Number(row.salesAmount) || 0;

          a.weightSum += weight;
          a.hasWeightedSum += hasPrice * weight;
          a.salesAmountSum += salesAmount;
          return a;
        },
        { weightSum: 0, hasWeightedSum: 0, salesAmountSum: 0 }
      );

      const avgHasPrice = acc.weightSum ? acc.hasWeightedSum / acc.weightSum : 0;
      const avgSalesPrice = acc.weightSum ? acc.salesAmountSum / acc.weightSum : 0;

      return { avgHasPrice, avgSalesPrice };
    }
  },
  methods: {
    getDate(day) {
      return new Date()
        .addDays(day)
        .toISOString()
        .substr(0, 10);
    },
    async initialize() {
      await this.$store.dispatch("reports/getOrderReports", {
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
      });
      await this.$store.dispatch("reports/getBestSellingProductsReports", {
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
      });
      this.uyumMonthly = (await Api.get(
        `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
          -30
        )}&endDate=${this.getDate(+1)}`
      )).data;
      this.uyumDaily = (await Api.get(
        `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
          0
        )}&endDate=${this.getDate(+1)}`
      )).data;
      this.orderMonthly = (await Api.get(
        `api/reports/GetOrderReports?startDate=${this.getDate(
          -30
        )}&endDate=${this.getDate(+1)}`
      )).data;
      this.productMonthly = (await Api.get(
        `api/reports/getBestSellingProductsReports?startDate=${this.getDate(
          -30
        )}&endDate=${this.getDate(+1)}`
      )).data;
      this.hasAverage = (await Api.get(
        `api/reports/getHasAverage?startDate=${this.getDate(
          0
        )}&endDate=${this.getDate(+1)}`
      )).data;
      await this.loadTotalGoldSentBetweenDates();
    },
    async loadTotalGoldSentBetweenDates() {
      this.goldSentLoading = true;
      try {
        const res = await Api.get(
          `api/orders/GetTotalGoldSentBetweenDates?startDate=${this.goldSentStartDate}&endDate=${this.goldSentEndDate}`
        );
        this.goldSentData = res.data || { totalGoldSent: 0, totalPayment: 0 };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Gönderilen altın özeti yüklenirken hata:', err);
        this.goldSentData = { totalGoldSent: 0, totalPayment: 0 };
      } finally {
        this.goldSentLoading = false;
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async loadNewOrdersSummary() {
      this.newOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getNewOrdersBankSummary', {
          startDate: this.newOrdersStartDate,
          endDate: this.newOrdersEndDate
        });
        this.newOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Yeni siparişler özeti yüklenirken hata:', error);
      } finally {
        this.newOrdersLoading = false;
      }
    },
    async loadCompletedOrdersSummary() {
      this.completedOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getCompletedOrdersBankSummary', {
          date: this.completedOrdersDate
        });
        this.completedOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Tamamlanan siparişler özeti yüklenirken hata:', error);
      } finally {
        this.completedOrdersLoading = false;
      }
    },
    async loadEaltinOrderControl() {
      this.ealtinOrderControlLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getEaltinOrderListExcel', {
          date: this.ealtinOrderControlDate
        });
        this.ealtinOrderControlList = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Gün bazında sipariş kontrol listesi yüklenirken hata:', error);
      } finally {
        this.ealtinOrderControlLoading = false;
      }
    },
    formatGold(value) {
      if (value === null || value === undefined) return '0.00 GR';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' GR';
    },
    formatNumber(value, digits = 2) {
      if (value === null || value === undefined) return '';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value);
    },
    formatDateOnly(value) {
      if (!value) return '';
      return new Date(value).toLocaleDateString('tr-TR');
    }
  },
  async mounted() {
    await this.initialize();
    if (this.tenantId === 2) {
      await this.loadNewOrdersSummary();
      await this.loadCompletedOrdersSummary();
      await this.loadEaltinOrderControl();
    }
  },
};
</script>

<style scoped>
.ealtin-order-control-table >>> .v-datatable__wrapper,
.ealtin-order-control-table >>> .v-data-table__wrapper,
.ealtin-order-control-table >>> .v-table__overflow {
  overflow-x: auto;
}
.ealtin-order-control-table >>> table {
  min-width: 2200px;
}
.text-no-wrap {
  white-space: nowrap;
}
</style>
